import * as Yup from 'yup';
import { locale } from '../../constants/locales';

export default Yup.object().shape({
    rename: Yup.string().required(locale.Messages.REQUIRED_FIELD),
});
